import { render } from "./WMTSLayer.vue?vue&type=template&id=1574059e"
import script from "./WMTSLayer.vue?vue&type=script&lang=js"
export * from "./WMTSLayer.vue?vue&type=script&lang=js"
script.render = render

export default script